import { GET_COUNTS, SET_COUNTS } from '../actions/actionTypes';

const initialState = {
  list: [],
  isLoading: false,
  isLoaded: false
};

const countsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_COUNTS:
      return { ...state, isLoading: true };
    case SET_COUNTS:
      return {
        ...state,
        list: action.counts,
        isLoaded: true,
        isLoading: false
      };
    default:
      return state;
  }
};

export default countsReducer;
